import * as actions from '../redux/actions';
import * as commonActions from '../../../common/redux/actions';

import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

const LoginBlock = props => {
  const openLoginModal = () => {
    props.actions.openCloseLoginModal(true);
  };

  return (
    <div className="pb-payment-details-login-block">
      <div className="kupos-card dont-have-account-block flex-row">
        <div>
          <div className="heading bold font13">{props.t('PASSENGER_DETAILS.NO_ACCOUNT')}</div>
          <div className="font10">{props.t('PASSENGER_DETAILS.CREATE_YOURS_AND_GET_BENIFIT')}</div>
        </div>
        <div>
          <button className="kupos-button font12" onClick={openLoginModal}>
            <span>{props.t('PASSENGER_DETAILS.CREATE_ACCOUNT')}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    pbPaymentDetails: state.pbPaymentDetails,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...commonActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginBlock);



// WEBPACK FOOTER //
// ./src/features/Pasajebus/PasajebusPaymentDetails/LoginBlock/LoginBlock.js